import { useState} from 'react';
import {Link} from 'react-router-dom';
import {GiHamburgerMenu} from 'react-icons/gi';
import {IoCloseOutline} from 'react-icons/io5';
import {MdOutlineArrowDropDown} from 'react-icons/md';
import Logo from "../images/pest_ex_logo_e_Transparent.png";
import AOS from 'aos';
import 'aos/dist/aos.css';
import Dropdown from './Dropdown';
import './navbar.css';

const Navbar = () => {

    const [click, setClick] = useState(false);
    const [dropdown, setDropdown] = useState(false);    
    const [dropdowntwo, setDropdownTwo] = useState(false); 


    const handleClick = () => setClick(!click);
    const closeMobileMenu = () => setClick(false);


    const onMouseEnter = () => {
        if(window.innerWidth < 960){
            setDropdown(false);
        }else{
            setDropdown(true);
        }
    };


    const onMouseLeave = () => {
        if(window.innerWidth < 960){
            setDropdown(false);
        }else{
            setDropdown(false);
        }
    };


    const handleTouchStart = () => {
        if(window.innerWidth < 960){
            setDropdown(true);
        }
    }
    
    const handleTouchEnd = () => {
        if(window.innerWidth < 960){
            setDropdown(true);
        }
    }

    const onMouseEnterTwo = () => {
        if(window.innerWidth < 960){
            setDropdownTwo(false);
        }else{
            setDropdownTwo(true);
        }
    };


    const onMouseLeaveTwo = () => {
        if(window.innerWidth < 960){
            setDropdownTwo(false);
        }else{
            setDropdownTwo(false);
        }
    };


    const handleTouchStartTwo = () => {
        if(window.innerWidth < 960){
            setDropdownTwo(true);
        }
    }
    
    const handleTouchEndTwo = () => {
        if(window.innerWidth < 960){
            setDropdownTwo(true);
        }
    }


    return (
        <>
            <nav className='navbar'>
                <Link to='/' className='logo'>
                    <img src={Logo} alt="pestexmasters-logo" />
                </Link>
                <div className="menu-icon" onClick={handleClick}>
                    <span className='burgerCloseMenu'>
                        {click ? <IoCloseOutline className='close-open-btn'/> : <GiHamburgerMenu className='close-open-btn'/>}
                    </span>
                </div>
                <ul className={click ? 'nav-menu active' : 'nav-menu'}>
                    <li className='nav-item'>
                        <Link to='./' className='nav-links'
                            onClick={closeMobileMenu}
                        >
                            Home
                        </Link>
                    </li>
                    <li className='nav-item'>
                        <Link to='/about' className='nav-links'
                            onClick={closeMobileMenu}
                        >
                            Who We Are
                        </Link>
                    </li>
                    <li className='nav-item services-nav-item'
                        onMouseEnter={onMouseEnter}
                        onMouseLeave={onMouseLeave}
                        onTouchStart={handleTouchStart}
                        onTouchEnd={handleTouchEnd}
                    >
                        <Link to='/Services' className='nav-links'
                            onClick={closeMobileMenu}
                        >
                            Services <MdOutlineArrowDropDown className='drop-down-arrow'/>
                        </Link>
                        {dropdown && <Dropdown/>}
                    </li>
                    <li className='nav-item'>
                    </li>
                    <li className='nav-item'>
                        <Link to='/contact' className='nav-links'
                            onClick={closeMobileMenu}
                        >
                            Get In Touch
                        </Link>
                    </li>
                                        <li className='nav-item'>
                        <Link to="/contact" 
                            className="homepage-header-btn btn lg"
                        >
                            Get A Quote
                        </Link>
                    </li>
                </ul>
            </nav>
        </>
    )
}

export default Navbar